export default __webpack_public_path__ + "static/media/vehicle-tracking.204eb3bd.png";